import { CollapsibleSection } from '@strata/react-collapsible-section';
import { PageTitle } from '@strata/react-page-title';

import { UserGuide } from './userGuide';
import { VideoGuide } from './videoGuide';

export const KnowledgeCenterPage = () => (
    <div className="margin__around--medium">
        <PageTitle title="Knowledge Center" className="padding__bottom--large" />
        <CollapsibleSection
            title="User Guides"
            className="sds_knowledge-center-section"
            content={
                <div className="sds_knowledge-center__user-guide__container margin__bottom--large">
                    <UserGuide
                        title="My Referrals"
                        navUrl="https://sseasacdn.blob.core.windows.net/fmh-for-pharmacies-knowledge-center/My Referrals User Guide.pdf"
                        id="my-referrals-user-guide-link"
                    />
                    <UserGuide
                        title="Patient Template"
                        navUrl="https://sseasacdn.blob.core.windows.net/fmh-for-pharmacies-knowledge-center/Patient Template User Guide.pdf"
                        id="patient-template-user-guide-link"
                    />
                    <UserGuide
                        title="Prescriber Lists"
                        navUrl="https://sseasacdn.blob.core.windows.net/fmh-for-pharmacies-knowledge-center/Prescriber Lists User Guide.pdf"
                        id="prescriber-lists-user-guide-link"
                    />
                    <UserGuide
                        title="Product Template"
                        navUrl="https://sseasacdn.blob.core.windows.net/fmh-for-pharmacies-knowledge-center/Product Template User Guide.pdf"
                        id="product-template-user-guide-link"
                    />
                    <UserGuide
                        title="State Lists"
                        navUrl="https://sseasacdn.blob.core.windows.net/fmh-for-pharmacies-knowledge-center/State Lists User Guide.pdf"
                        id="state-lists-user-guide-link"
                    />
                    <UserGuide
                        title="User Notification Settings"
                        navUrl="https://sseasacdn.blob.core.windows.net/fmh-for-pharmacies-knowledge-center/Notification Settings User Guide.pdf"
                        id="notifications-user-guide-link"
                    />
                    <UserGuide
                        title="Worklist Tasks"
                        navUrl="https://sseasacdn.blob.core.windows.net/fmh-for-pharmacies-knowledge-center/Worklist Tasks User Guide.pdf"
                        id="worklist-tasks-user-guide-link"
                    />
                </div>
            }
        />
        <CollapsibleSection
            title="Video Guides"
            className="sds_knowledge-center-section"
            content={
                <div className="sds_knowledge-center__video-guide__container margin__bottom--large">
                    <VideoGuide
                        thumbnailURL="https://sseasacdn.blob.core.windows.net/fmh-for-pharmacies-knowledge-center/application-overview-thumbnail.png"
                        title="FMH for Pharmacies Application Overview"
                        navUrl="https://sseasacdn.blob.core.windows.net/fmh-for-pharmacies-knowledge-center/Application Overview.mp4"
                        id="fmh-overview-video-guide-link"
                    />
                    <VideoGuide
                        thumbnailURL="https://sseasacdn.blob.core.windows.net/fmh-for-pharmacies-knowledge-center/live-referrals-thumbnail.png"
                        title="Live Referrals"
                        navUrl="https://sseasacdn.blob.core.windows.net/fmh-for-pharmacies-knowledge-center/Live Referrals.mp4"
                        id="live-referrals-video-guide-link"
                    />
                    <VideoGuide
                        thumbnailURL="https://sseasacdn.blob.core.windows.net/fmh-for-pharmacies-knowledge-center/my-referrals-thumbnail.png"
                        title="My Referrals"
                        navUrl="https://sseasacdn.blob.core.windows.net/fmh-for-pharmacies-knowledge-center/My Referrals.mp4"
                        id="my-referrals-video-guide-link"
                    />
                    <VideoGuide
                        thumbnailURL="https://sseasacdn.blob.core.windows.net/fmh-for-pharmacies-knowledge-center/notifications-thumbnail.png"
                        title="Notifications"
                        navUrl="https://sseasacdn.blob.core.windows.net/fmh-for-pharmacies-knowledge-center/Notifications.mp4"
                        id="notifications-video-guide-link"
                    />
                    <VideoGuide
                        thumbnailURL="https://sseasacdn.blob.core.windows.net/fmh-for-pharmacies-knowledge-center/patient-template-thumbnail.png"
                        title="Patient Template"
                        navUrl="https://sseasacdn.blob.core.windows.net/fmh-for-pharmacies-knowledge-center/Patient Template.mp4"
                        id="patient-template-video-guide-link"
                    />
                    <VideoGuide
                        thumbnailURL="https://sseasacdn.blob.core.windows.net/fmh-for-pharmacies-knowledge-center/performance-thumbnail.png"
                        title="Performance"
                        navUrl="https://sseasacdn.blob.core.windows.net/fmh-for-pharmacies-knowledge-center/Performance.mp4"
                        id="performance-video-guide-link"
                    />
                    <VideoGuide
                        thumbnailURL="https://sseasacdn.blob.core.windows.net/fmh-for-pharmacies-knowledge-center/prescriber-lists-thumbnail.png"
                        title="Prescriber Lists"
                        navUrl="https://sseasacdn.blob.core.windows.net/fmh-for-pharmacies-knowledge-center/Prescriber List.mp4"
                        id="prescriber-lists-video-guide-link"
                    />
                    <VideoGuide
                        thumbnailURL="https://sseasacdn.blob.core.windows.net/fmh-for-pharmacies-knowledge-center/product-template-thumbnail.png"
                        title="Product Template"
                        navUrl="https://sseasacdn.blob.core.windows.net/fmh-for-pharmacies-knowledge-center/Product Template.mp4"
                        id="product-template-video-guide-link"
                    />
                    <VideoGuide
                        thumbnailURL="https://sseasacdn.blob.core.windows.net/fmh-for-pharmacies-knowledge-center/state-lists-thumbnail.png"
                        title="State Lists"
                        navUrl="https://sseasacdn.blob.core.windows.net/fmh-for-pharmacies-knowledge-center/State Lists.mp4"
                        id="state-lists-video-guide-link"
                    />
                    <VideoGuide
                        thumbnailURL="https://sseasacdn.blob.core.windows.net/fmh-for-pharmacies-knowledge-center/worklist-thumbnail.png"
                        title="Worklist"
                        navUrl="https://sseasacdn.blob.core.windows.net/fmh-for-pharmacies-knowledge-center/Worklist.mp4"
                        id="worklist-video-guide-link"
                    />
                </div>
            }
        />
    </div>
);
